import { render } from "./AboutClubComponent.vue?vue&type=template&id=408a995d"
const script = {}

import "./AboutClubComponent.vue?vue&type=style&index=0&id=408a995d&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__